import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import ProductFeaturesPage from '../pages/Features/ProductFeaturesPage';
import PricingPage from '../pages/Pricing/PricingPage';
import CustomerCasesPage from '../pages/CaseStudies';

/**
 * 应用程序路由组件
 * 集中管理所有路由配置
 * @returns {JSX.Element} 渲染的路由组件
 */
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* 其他路由 */}
      <Route path="/features" element={<ProductFeaturesPage />} />
      <Route path="/solutions" element={<div>行业方案页面</div>} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/case-studies" element={<CustomerCasesPage />} />
      <Route path="/cases" element={<CustomerCasesPage />} />
      <Route path="/faq" element={<div>常见问题页面</div>} />
      <Route path="/contact" element={<div>联系我们页面</div>} />
    </Routes>
  );
};

export default AppRoutes;